import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { GetUserLocationWorkflowNode } from '@blaze-shared/workflow-domain';

import { COLUMN_SOURCE_ID, NODE_SOURCE_ID } from '../../errors/source-ids';
import { WorkflowError } from '../../errors/workflow-error';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('GetUserLocation')
export class GetUserLocationNode extends BaseWorkflowNode<GetUserLocationWorkflowNode> {
  static readonly NODE_SOURCE_ID = NODE_SOURCE_ID;
  static readonly ERROR_VALUE_SOURCE_ID = COLUMN_SOURCE_ID;

  getColumnReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [];
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }

  override validate(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowError<any>[] {
    const errors = super.validate(schemas, connectors);
    return errors;
  }
}
